// src/components/report/WelcomeMessage.js
import React from 'react';

const WelcomeMessage = () => (
    <div className="bg-white rounded-xl p-6 shadow-lg mb-6">
        <div className="prose max-w-none">
            <h2 className="text-xl font-bold text-[#234363] mb-4 text-center">
            عميل تيسير العزيز
            </h2>
            <div className="text-gray-600 leading-relaxed space-y-4">
                <p>
                مع نهاية سنة ٢٠٢٤، إحنا فخورين نشارك معاك تقريرك السنوي. مش مجرد أرقام... ده رحلة تحويش وكفاح، كل ملليجرام دهب اتجمع السنة دي خطوة في الطريق الصح.
                </p>
                <p>
                التقرير هيشرحلك بالتفصيل رحلتك في التحويش، وإزاي الدهب ساعدك تحافظ على قيمة فلوسك. 
                وكمان هتلاقي نصائح تساعدك تخطط لتحويش 2025 بشكل أحسن.
                </p>
                <p>
                اقرا تقريرك واحتفل بإنجازاتك، ولو عندك أي استفسار تيسير معاك دايماً.
                </p>

            </div>
        </div>
    </div>
);

export default WelcomeMessage;